module.exports = __webpack_public_path__ + "static/media/img-6.eefe6c9e.jpg";